export default "__VITE_ASSET__BCZwH1UT__"